import type { UpsertUserTablePreferencesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpsertUserTablePreferencesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface UpsertUserTablePreferencesInput {
  TableId: string;
  Preferences: unknown;
}

export const useUpsertUserTablePreferences = createMutationHook({
  // Per-user UI preference — cannot change any register's row count, so it
  // skips the collapsed nav-badge refetch (COI-908). Without this every column
  // reorder or recent-user write would run all 26 counts.
  invalidatesNavCounts: false,
  name: 'upsertUserTablePreferences',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userTablePreferences.upsertUserTablePreferences.mutationOptions(
      { onSuccess }
    ),
  mapInput: (input: UpsertUserTablePreferencesInput) => ({
    tableId: input.TableId,
    Preferences: input.Preferences,
  }),
  // The pre-factory twin invalidated this read keyed by the written tableId
  // (from the mutation variables); `invalidate` cannot see the variables, so
  // this uses the procedure-level prefix key, which matches every
  // per-tableId instance including the written one.
  invalidate: (trpc) => [
    trpc.frontend.userTablePreferences.userTablePreferences.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): UpsertUserTablePreferencesMutation => ({
    insert_user_table_preferences: {
      __typename: 'user_table_preferences_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: UpsertUserTablePreferencesDocument,
  graphqlVariables: (input) => ({
    TableId: input.TableId,
    Preferences: input.Preferences,
  }),
});
